(ns ui.components.layout.view)

(defn flex-flow
  [& children]
  (into
   [:div
    {:class "w-full flex gap-3 align-top flex-1"}]
   children))

(defn flex-row
  [& children]
  (into
   [:div
    {:class "flex gap-3 justify-between  flex-1"}]
   children))

(defn flex-column
  [& children]
  (into
   [:div
    {:class "flex flex-col gap-3 flex-1"}]
   children))

(defn remaining-space
  []
  [:div
   {:class "flex-1"}])

(defn right-align
  [& children]
  (into [:div
         {:class "flex-1 flex flex-row gap-2 justify-end"}]
        children))

(defn left-align
  [& children]
  (into [:div
         {:class "flex flex-row gap-2 justify-start"}]
        children))

(defn row
  [& children]
  (into [:div
         {:class "flex-0 flex flex-row gap-1"}]
        children))
